import React, { useState, useEffect , useRef } from "react";
import { Phone, Lock, Store, Eye, EyeOff} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { loginMerchant, restoreSession } from "../../../features/merchant/merchantThunks";
import { navigateTo } from "../../../utils/navigation";
import { toast } from "react-toastify";
import api from "../../../api/axiosInstance";
import logo from "../../../assets/images/mszila-border-logo.png";
import featureFlags from "../../../config/featureFlags";

const Login = () => {
  const dispatch = useDispatch();
  // FIX 5: Select both 'user' and 'accessToken' directly from Redux state
  const { loading, user, accessToken, error } = useSelector(
    (state) => state.merchant);
    
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const redirectedRef = useRef(false);
  // -------------------------
  // HANDLE LOGIN SUBMISSION
  // -------------------------
const handleLogin = async (e) => {
  e.preventDefault();

  if (!mobileNumber || !password) {
    toast.error("Please enter both mobile number and password");
    return;
  }

  try {
    // STEP 1: CHECK MOBILE AND GET ROLE
    const check = await api.post("/api/auth/check-mobile", {
      mobileNumber: mobileNumber.trim(),
    });

    if (!check.data.exists) {
      toast.error("Mobile number not registered");
      return;
    }

    const userRole = check.data.role; // "merchant" or "user"

    // STEP 2: LOGIN PAYLOAD
    const payload = {
      mobileNumber: mobileNumber.trim(),
      password: password.trim(),
      role: userRole,
    };

    // STEP 3: DISPATCH CORRECT LOGIN THUNK
    const result = await dispatch(loginMerchant(payload));

    if (!loginMerchant.fulfilled.match(result)) {
      toast.error("Invalid login credentials");
      return;
    }

  toast.success("Login successful!");
  } catch (err) {
    toast.error(err.response?.data?.message || "Something went wrong");
  }
};



  // -------------------------
  // SHOW ERROR FROM REDUX
  // -------------------------
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  // -------------------------
  // FIX 6: HANDLE SUCCESS LOGIN AND REDIRECT (Based on Redux state only)
  // -------------------------
useEffect(() => {
  if (!user || !accessToken) return;
  if (redirectedRef.current) return;

  redirectedRef.current = true;

  if (user.role === "merchant") {
    if (!user.isEnquiryCompleted) {
      navigateTo("/merchant-inquiry");
      return;
    }

    if (user.enquiryStatus === "incomplete") {
      navigateTo("/inquiry-status");
      return;
    }

    if (user.enquiryStatus === "paymentPending") {
      navigateTo(featureFlags.ENABLE_MERCHANT_SUBSCRIPTION ? "/buy-subscription" : "/dashboard");
      return;
    }

    if (user.enquiryStatus === "paymentComplete") {
      navigateTo("/dashboard");
      return;
    }
  }

  if (user.role === "user") {
    if (!user.isEnquiryCompleted) {
      navigateTo("/profile");
      return;
    }

    if (user.enquiryStatus === "incomplete") {
      navigateTo(featureFlags.ENABLE_USER_SUBSCRIPTION ? "/buy-subscription" : "/dashboard");
      return;
    }

    if (user.enquiryStatus === "paymentComplete") {
      navigateTo("/dashboard");
      return;
    }
  }
}, [user, accessToken]);

 // Depend on both user and accessToken
 
  return (
    <div className="register-container">
      <div className="register-card">
        {/* Back Button */}
        <button className="back-button" type="button" onClick={() => navigateTo(-1)}>
          ←
        </button>

        {/* Header */}
        <div className="step-header">
            <a className="logo-section justify-content-center" href="/">
                      <img
                    src={logo}
                   alt="MSZILA Logo"
                    className="navbar-logo"
                   />
                 </a>
          <h1 className="step-title">Welcome To Login! 👋</h1>
          <p className="step-subtitle">Sign in to your registered account</p>
        </div>

        {/* Form */}
        <form className="form-content" onSubmit={handleLogin}>
          {/* Mobile Number Input */}
          <div className="form-group">
            <div className="input-container">
              <span className="input-icon">
                <Phone size={20} />
              </span>
              <input
                type="tel"
                className="form-input"
                placeholder="Mobile Number"
                autoComplete="tel"
                maxLength="10"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          {/* Password Input */}
         <div className="form-group">
            <div className="input-container" style={{ position: "relative" }}>
              <span className="input-icon"><Lock size={20} /></span>

              <input
                type={showPassword ? "text" : "password"}
                className="form-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  cursor: "pointer",
                  color: "#6b7280",
                }}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>
          </div>

          {/* Forgot Password */}
          <div style={{ textAlign: "right", marginBottom: "20px" }}>
            <span
              onClick={() => navigateTo("/forget-password")}
              style={{
                fontSize: "14px",
                color: "#6366f1",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              Forgot Password?
            </span>
          </div>

          {/* Login Button */}
          <button type="submit" className="primary-button" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Register link */}
        {/* Register Link */}
        <div className="login-section">
          Don't have an account?{' '}
          <span
            className="login-link"
            onClick={() => navigateTo('/register')}
            style={{ cursor: 'pointer' }}> Register
          </span>
        </div>

        {/* merchant Register Link */}
        <div className="login-section">
          Create the account as Merchant ?{' '}
          <span
            className="login-link"
            onClick={() => navigateTo('/merchant-register')}
            style={{ cursor: 'pointer' }}>
            Register Merchant <Store size={18} className="text-primary mb-1" stroke="#6366f1" />
          </span>
        </div>
      </div>
    </div>
  );
};
export default Login;